import { Box } from '@mui/material';
import { company } from '../../config/company';
import { images } from '../../config/images';

export default function SedexLogo({ tone = 'light', height = 40, sx }) {
  const logo = images[company.compliance.sedexLogoAsset];
  if (!logo?.positive || !logo?.negative) return null;
  const displayWidth = Math.round((height * logo.width) / logo.height);

  return (
    <Box
      component="img"
      src={tone === 'dark' ? logo.negative : logo.positive}
      alt={logo.alt}
      width={logo.width}
      height={logo.height}
      loading="lazy"
      decoding="async"
      sx={[
        {
          display: 'block',
          width: `min(100%, ${displayWidth}px)`,
          height: 'auto',
        },
        sx,
      ]}
    />
  );
}
